import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../../Styles/globals.css"
import { Outlet } from "react-router-dom";

const Main = ({ children }) => {
  return (
    <>
    <Header />
    <div style={{padding:"10px",marginBottom:"20px"}}>
    <Outlet />
    </div>
    <Footer />
    
    </>
  );
};

export default Main;